/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meal-advise.reducer';

export const MealAdviseDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mealAdviseEntity = useAppSelector(state => state.mealAdvise.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mealAdviseDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mealAdvise.detail.title">MealAdvise</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mealAdvise.id">Id</Translate>
            </span>
          </dt>
          <dd>{mealAdviseEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.mealAdvise.active">Active</Translate>
            </span>
          </dt>
          <dd>{mealAdviseEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.mealAdvise.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{mealAdviseEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.mealAdvise.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{mealAdviseEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.mealAdvise.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{mealAdviseEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.mealAdvise.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{mealAdviseEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealAdvise.mealDetailsSchedule">Meal Details Schedule</Translate>
          </dt>
          <dd>{mealAdviseEntity.mealDetailsSchedule ? mealAdviseEntity.mealDetailsSchedule.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealAdvise.recipeMealDetails">Recipe Meal Details</Translate>
          </dt>
          <dd>{mealAdviseEntity.recipeMealDetails ? mealAdviseEntity.recipeMealDetails.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealAdvise.advisedBy">Advised By</Translate>
          </dt>
          <dd>{mealAdviseEntity.advisedBy ? mealAdviseEntity.advisedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealAdvise.nutritionPlan">Nutrition Plan</Translate>
          </dt>
          <dd>{mealAdviseEntity.nutritionPlan ? mealAdviseEntity.nutritionPlan.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/meal-advise" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meal-advise/${mealAdviseEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MealAdviseDetail;
